import React from 'react';
import {Icon, IconButton, Image} from "@chatui/core";

function ImageInput(props) {

    const {
        images,
        setImages,
    } = props;
    const addingImage = (event) => {
        let e = window.event || event  // change事件获取到的数据
            if (e.target.files[0].size > 500 * 1024 * 1024) { // 限制文件上传大小
                console.error('上传单个文件大小不能超过 500M!')
            } else {
                const newImgs = [...images];
                const file = event.target.files[0];
                newImgs.push(URL.createObjectURL(file));
                setImages(newImgs);
            }
    };
    const deleteImage = (index) => {
        const newImgs = [...images];
        newImgs.splice(index,1);
        setImages(newImgs);
    };
    return (
        <div>

            {/*图片项*/}
            {images.map((url, index)=>(
                <div className={"image-item"} key={index}>

                    {/*图片*/}
                    <Image
                        className={"image"}
                        src={url}
                    ></Image>

                    {/*删除图片按钮*/}
                    <IconButton
                        className={"icon"}
                        icon={"close"}
                        onClick={() => {deleteImage(index);}}
                    ></IconButton>
                </div>
            ))}

            {/*新增图片按钮*/}
            <div className="project-img-btn">
                <input type="file" className="picUpload" onChange={(e)=>addingImage(e)}/>
                <Icon className="add-icon" type="plus" />
            </div>
        </div>
    );
}

export default ImageInput;